import { getConditionalObject } from 'utils/data';

export const getListStyles = isNestedList => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '100%',
  padding: 0,

  ...getConditionalObject(isNestedList, {
    paddingLeft: '32px',
  }),
});

export const listItemStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '100%',
  padding: 0,
};
